{
  "actionbar.actions": "Aktionen",
  "actionbar.actionsAvailable": "Aktionen verfügbar.",
  "actionbar.clearSelection": "Auswahl löschen",
  "actionbar.selected": "{count, plural, =0 {Nichts ausgewählt} one {# ausgewählt} other {# ausgewählt}}",
  "actionbar.selectedAll": "Alles ausgewählt",
  "button.pending": "Ausstehend",
  "contextualhelp.help": "Hilfe",
  "contextualhelp.info": "Informationen",
  "dialog.alert": "Warnhinweis",
  "dialog.dismiss": "Schließen",
  "dropzone.replaceMessage": "Datei zum Ersetzen ablegen",
  "inlinealert.informative": "Informationen",
  "inlinealert.negative": "Fehler",
  "inlinealert.notice": "Warnung",
  "inlinealert.positive": "Erfolg",
  "label.(optional)": "(optional)",
  "label.(required)": "(erforderlich)",
  "menu.moreActions": "Mehr Aktionen",
  "picker.placeholder": "Auswählen…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Laden...",
  "table.loadingMore": "Mehr laden ...",
  "table.resizeColumn": "Spaltengröße ändern",
  "table.sortAscending": "Aufsteigend sortieren",
  "table.sortDescending": "Absteigend sortieren",
  "tag.actions": "Aktionen",
  "tag.hideButtonLabel": "Weniger zeigen",
  "tag.noTags": "Keine",
  "tag.showAllButtonLabel": "Alle anzeigen ({tagCount, number})",
  "breadcrumbs.more": "Weitere Elemente"
}